<tec-item
    [classes]="['item--outline']"
    [tagImage]="{ icon: 'icon-shield', status: 'simple' }"
    [tagIcon]="tagIcon"
    [title]="'PROCESSES.DETAIL.FRAUD_FACE' | translate"
    [clickeable]="false"
/>
